export const AdminGroupErrorHandleFields = {
  name: {
    required: 'Please provide name',
  },
};
